<div [ngStyle]="{ 'display' : procedureController.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <div class="fields__container__tabs">
    <div
      class="fields__container__tabs__item"
      (click)="activatePrimaryData()"
    >
      <a [ngClass]="primaryDataActive ? 'active' : ''" href="#" data-tab="1"
        >Procedure Settings</a
      >
    </div>
    <div
      class="fields__container__tabs__item"
      (click)="activateLegsData()"
    >
      <a [ngClass]="legsDataActive ? 'active' : ''" href="#" data-tab="1"
        >Procedure Legs</a
      >
    </div>
    <div
      class="fields__container__tabs__item"
      (click)="activateNavaidsData()"
    >
      <a [ngClass]="navaidsDataActive ? 'active' : ''" href="#" data-tab="1"
        >Procedure Navaids</a
      >
    </div>
  </div>
  <form autocomplete="off"
    id="ngForm1"
    name="ngForm1"
    #ngForm1="ngForm" class="margin-tabs"
    [ngClass]="[primaryDataActive ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']"
    data-tab="1"
    id="procedurePrimaryForm"
  >
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Procedure Description</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Identifier</label
            ><input
              required
              [disabled]="selectCoordinatePointService.selectedProcedure.iDNotEditable"
              maxlength="50"
              minlength="1"
              type="text"
              name="procedureid"
              id="procedureid"
              [(ngModel)]="selectCoordinatePointService.selectedProcedure.procedureid"
              #procedureId="ngModel"
              alphaNumeric
              (blur)="validateProcedureIdentifier(selectCoordinatePointService.selectedProcedure.procedureid)"
            />
            <span class="error" *ngIf=" (procedureId.dirty || procedureId.touched)
            && procedureId.errors?.nonAlphaNumeric">
              Only alphanumeric characters, hyphens and underscores are allowed.
            </span>
          </div>
          <div>
            <label for="">Name</label
            ><input
              required
              [disabled]="selectCoordinatePointService.selectedProcedure.iDNotEditable"
              type="text"
              id="procedurename"
              name="procedurename"
              [(ngModel)]="selectCoordinatePointService.selectedProcedure.name"
              alphaNumeric
              #name="ngModel"
            />
            <span class="error" *ngIf=" (name.dirty || name.touched)
            && name.errors?.nonAlphaNumeric">
              Only alphanumeric characters, hyphens and underscores are allowed.
            </span>
          </div>
        </div>
        <div class="dropdown-fields">
          <div>
            <label for="">Procedure Type</label>
            <select
              name="proceduretype"
              (change)="changeProcedureType($event)"
            >
              <option value="SID" selected>SID</option>
              <option value="STAR">STAR</option>
              <option value="ENROUTE">EN-ROUTE</option>
            </select>
          </div>
        </div>
        <div class="dropdown-fields">
          <div>
            <label for="">RNAV Performance Type</label>
            <select
              [(ngModel)]="selectCoordinatePointService.selectedProcedure.rnavperformancetype"
              name="rnavperformancetype"
              #rnavperformancetype="ngModel"
            >
              <option value="B_RNAV">RNAV-5 (B-RNAV)</option>
              <option value="P_RNAV">RNAV-1 (P-RNAV)</option>
              <option value="A_RNP">A-RNP</option>
            </select>
          </div>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Reference Airport</label>
            <ng-autocomplete
              [data]="this.selectCoordinatePointService.airportsCoordinatePoints"
              [searchKeyword]="keyword"
              placeholder="Airport"
              historyIdentifier="airports"
              (selected)='selectAirport($event)'
              [itemTemplate]="itemTemplate"
              [notFoundTemplate]="notFoundTemplate"
              class="airportField"
              [initialValue]="this.selectCoordinatePointService.selectedAirport"
              [(ngModel)]="this.selectCoordinatePointService.selectedAirport"
              name="selectedAirport"
              style="width: 50%;"

              >
            </ng-autocomplete>
            <ng-template #itemTemplate let-item>
              <a *ngIf="item.composedName != null" [innerHTML]="item.composedName"></a>
              <a *ngIf="item.composedName == null" [innerHTML]="item"></a>
            </ng-template>

            <ng-template #notFoundTemplate let-notFound>
              <div [innerHTML]="notFound"></div>
            </ng-template>
            <div class="btn" style="width: auto;">
              <button
              type="submit"
              style="margin-right: none;"
              class="grey"
              (click)="this.activateSelectOnMapAirport();"
              [disabled]="false">Select from map</button>
            </div>
          </div>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Aircraft Speed</label>
            <div class="coordenates">
              <input
                type="number"
                style="width: 60%"
                id="doc"
                name="doc"
                [(ngModel)]="selectCoordinatePointService.selectedProcedure.aircraftspeed"
                (ngModelChange)="isValueValid('Aircraft_Speed', selectCoordinatePointService.selectedProcedure.aircraftspeed)"
              /><span>[Kts]</span>
              <span class="error" *ngIf="!selectCoordinatePointService.aircraftSpeedValid">
                The Aircraft Speed value must be defined between 1 and 3.4028235E38 kts.
              </span>
          </div>
          </div>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Notes</label
              ><input
                required
                type="text"
                id="name"
                name="name"
              />
          </div>
        </div>
      </div>
    </div>
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Procedure Coordinate Points</h4>
          <span> </span>
        </div>
        <div class="table-fields">
          <div>
            <label for="">Procedure Coordinate Points</label>
            <div class="scrollable">
              <table >
                <thead>
                  <tr>
                    <th style="width: 15%;">Id</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">WPT Type</th>
                    <th scope="col" style="width: 10%;">Latitude</th>
                    <th scope="col" style="width: 10%;">Longitude</th>
                    <th scope="col" style="width: 10%;">Altitude [ft]</th>
                  </tr>
                </thead>
                <tbody>
                  <tr mdbTableCol *ngFor="let el of selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints;let i = index "
                    (click)="selectCoordinatePointService.selectProcedureCoordinatePointRow(el, selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints)"
                    [class.highlighted]="el.coordPoint.isselected">
                      <td *ngIf="!el.coordPoint.published" scope="col" style="width: 6%;">
                        <input required [(ngModel)]="el.coordPoint.coordpointid" maxlength="5" name="id_{{i}}"
                         [(ngModel)]="el.coordPoint.coordpointid" type="text" alphaNumeric (blur)="validateProcedureCoordinatePoints(el.coordPoint)"/></td>
                    <td *ngIf="el.coordPoint.published" scope="col">{{ el.coordPoint.coordpointid }}</td>
                    <td *ngIf="!el.coordPoint.published" scope="col">
                      <input required [(ngModel)]="el.coordPoint.name" name="name_{{i}}" value="{{el.coordPoint.name}}" alphaNumeric [disabled]="el.coordPoint.published? true : false" />
                    </td>
                    <td *ngIf="el.coordPoint.published" scope="col">{{ el.coordPoint.name }}</td>
                    <td scope="col">{{ el.coordPoint.type }}</td>
                    <td scope="col">
                      <select
                      name="procedurecoordpointtype_{{i}}"
                      id="procedurecoordpointtype"
                      value = "{{ el.procedurecoordpointtype }}"
                      (blur)="saveProcedureCoordinatePointTypeChange($event, el)"
                    >
                      <option></option>
                      <option value="Fly-Over">Fly-Over</option>
                      <option value="Fly-By">Fly-By</option>
                      <option value="DEP">DEP</option>
                      <option value="ENR">ENR</option>
                      <option value="IAWP">IAWP</option>
                      <option value="IAF">IAF</option>
                      <option value="IWP">IWP</option>
                      <option value="IF">IF</option>
                      <option value="FAWP">FAWP</option>
                      <option value="FAF">FAF</option>
                      <option value="LTP">LTP</option>
                      <option value="MAWP">MAWP</option>
                      <option value="MAPt">MAPt</option>
                    </select>
                    </td>
                    <td *ngIf="!el.coordPoint.published  && !selectCoordinatePointService.selectedProcedure.latLonNotEditable" scope="col" style="width: 10%;"><input [(ngModel)]="el.coordPoint.latitude" name="latitude_{{i}}" [disabled]="el.coordPoint.published? true : false" value="{{ el.coordPoint.latitude }}"/></td>
                    <td *ngIf="el.coordPoint.published  || selectCoordinatePointService.selectedProcedure.latLonNotEditable" scope="col" style="width: 10%;">{{ el.coordPoint.latitude }}</td>
                    <td *ngIf="!el.coordPoint.published && !selectCoordinatePointService.selectedProcedure.latLonNotEditable" scope="col" style="width: 10%;"><input [(ngModel)]="el.coordPoint.longitude" name="longitude_{{i}}" [disabled]="el.coordPoint.published? true : false" value="{{ el.coordPoint.longitude }}"/></td>
                    <td *ngIf="el.coordPoint.published || selectCoordinatePointService.selectedProcedure.latLonNotEditable" scope="col" style="width: 10%;">{{ el.coordPoint.longitude }}</td>
                    <td scope="col"><input name="altitude_{{i}}" type="number" value="{{ el.altitude }}" (blur)="saveProcedureCoordinatePointAltitudeChange($event, el)"/></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="btn">
              <button type="submit" (click)="deleteCoordinatePointFromList()" [ngClass]="selectCoordinatePointService.isCoordinatePointSelected(selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints) ? 'blue' : 'gray'" [disabled]="!selectCoordinatePointService.isCoordinatePointSelected(selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints)">Delete</button>
              <button type="submit" (click)="changePosition('up')" [ngClass]="selectCoordinatePointService.isCoordinatePointSelected(selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints) ? 'blue' : 'gray'" [disabled]="!selectCoordinatePointService.isCoordinatePointSelected(selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints)">Up</button>
              <button type="submit" (click)="changePosition('down')" [ngClass]="selectCoordinatePointService.isCoordinatePointSelected(selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints) ? 'blue' : 'gray'" [disabled]="!selectCoordinatePointService.isCoordinatePointSelected(selectCoordinatePointService.selectedProcedure.procedureCoordinatePoints)">Down</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__btn">
      <button
        type="submit"
        [ngClass]="ngForm1.form.valid && projectService.activeProject?.editable? 'blue' : 'gray'"
        [disabled]="!ngForm1.form.valid || !projectService.activeProject?.editable"
        (click)="saveProcedure()"
      >Save</button>
      <a
        class="gray"
        href="#"
        type="reset"
        value="Cancel"
        (click)="tabsService.closeTab()"
        >Cancel</a>
    </div>
  </form>
  <form autocomplete="off"
    id="ngForm2"
    name="ngForm2"
    #ngForm2="ngForm"
    [ngClass]="[legsDataActive ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']"
    data-tab="1"
    id="navaidPrimaryForm"
  >
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Procedure Legs</h4>
          <span> </span>
        </div>
        <div class="table-fields">
          <div>
            <div class="scrollable" style="display: block;width: 100%;">
              <table >
                <thead >
                  <tr >
                    <th >Id</th>
                    <th  scope="col">Start Point</th>
                    <th scope="col">End Point</th>
                  </tr>
                </thead>
                <tbody >
                  <tr mdbTableCol *ngFor="let el of selectCoordinatePointService.selectedProcedure.procedureLegs"
                  (click)="selectCoordinatePointService.selectProcedureLegRow(el, selectCoordinatePointService.selectedProcedure.procedureLegs)"
                    [class.highlighted]="el.isselected">
                    <td>{{ el.procedurelegid.split('_')[0] }}</td>
                    <td scope="col">{{ el.startPoint.coordPoint.coordpointid }}</td>
                    <td scope="col">{{ el.endPoint.coordPoint.coordpointid }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Leg Definition</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Start Point</label>
            <label for="">{{ selectCoordinatePointService.selectedProcedureLeg != undefined? selectCoordinatePointService.selectedProcedureLeg.startPoint.coordPoint.coordpointid : "No Point Defined" }}</label>
            <div class="btn">
              <button
              type="submit"
              class="grey"
              (click)="this.activateSelectOnMapLegStartPoint();"
              [disabled]="selectCoordinatePointService.selectedProcedureLeg != undefined? false : true">Select from map</button>

            </div>
          </div>
          <div>
            <label for="">End Point</label>
            <label for="">{{ selectCoordinatePointService.selectedProcedureLeg != undefined? selectCoordinatePointService.selectedProcedureLeg.endPoint.coordPoint.coordpointid : "No Point Defined" }}</label>
            <div class="btn">
              <button
              type="submit"
              class="grey"
              (click)="this.activateSelectOnMapLegEndPoint();"
              [disabled]="selectCoordinatePointService.selectedProcedureLeg != undefined? false : true">Select from map</button>

            </div>
          </div>
          <div>
            <label for="">Fix Point Latitude</label>
            <div class="coordenates">
              <div>
                <select
                style="width: auto"
                name="latCardinal"
                [disabled]="selectCoordinatePointService.selectedProcedureLeg != undefined? selectCoordinatePointService.isStraightlLeg : true"
                [(ngModel)]="selectCoordinatePointService.activeFixPoint.latLonDms.latitude.cardinal"
                (ngModelChange)="selectCoordinatePointService.activeFixPoint.latitude = selectCoordinatePointService.activeFixPoint.latLonDms.toLat()"
              >
                <option value="N">N</option>
                <option value="S">S</option>
              </select>
              <input
                type="number"
                id="latDegrees"
                name="latDegrees"
                style="width: 16%"
                [(ngModel)]="selectCoordinatePointService.activeFixPoint.latLonDms.latitude.degrees"
                (ngModelChange)="selectCoordinatePointService.activeFixPoint.latitude = selectCoordinatePointService.activeFixPoint.latLonDms.toLat()"
                [disabled]="selectCoordinatePointService.selectedProcedureLeg != undefined? selectCoordinatePointService.isStraightlLeg : true"
              /><span>º</span
              ><input
                type="number"
                id="latMinutes"
                name="latMinutes"
                style="width: 16%"
                [(ngModel)]="selectCoordinatePointService.activeFixPoint.latLonDms.latitude.minutes"
                (ngModelChange)="selectCoordinatePointService.activeFixPoint.latitude = selectCoordinatePointService.activeFixPoint.latLonDms.toLat()"
                [disabled]="selectCoordinatePointService.selectedProcedureLeg != undefined? selectCoordinatePointService.isStraightlLeg : true"
              /><span>´</span
              ><input
                type="number"
                id="latSeconds"
                name="latSeconds"
                style="width: 16%"
                [(ngModel)]="selectCoordinatePointService.activeFixPoint.latLonDms.latitude.seconds"
                (ngModelChange)="selectCoordinatePointService.activeFixPoint.latitude = selectCoordinatePointService.activeFixPoint.latLonDms.toLat()"
                [disabled]="selectCoordinatePointService.selectedProcedureLeg != undefined? selectCoordinatePointService.isStraightlLeg : true"
              /><span>´´</span>
              </div>
              <br /><input
                type="number"
                style="width: 75%; margin-top: 5px;margin-bottom:5px;"
                id="latitude"
                name="latitude"
                [(ngModel)]="selectCoordinatePointService.activeFixPoint.latitude"
                (ngModelChange)="selectCoordinatePointService.activeFixPoint.latLonDms.fromLat(selectCoordinatePointService.activeFixPoint.latitude)"
                [disabled]="selectCoordinatePointService.selectedProcedureLeg != undefined? selectCoordinatePointService.isStraightlLeg : true"
                required
              /><span></span>
            </div>
          </div>
          <div>
            <label for="">Longitude</label>
            <div class="coordenates">
              <div>
                <select
                name="lonCardinal"
                style="width: auto"
                [disabled]="selectCoordinatePointService.selectedProcedureLeg != undefined? selectCoordinatePointService.isStraightlLeg : true"
                [(ngModel)]="selectCoordinatePointService.activeFixPoint.latLonDms.longitude.cardinal"
                (ngModelChange)="selectCoordinatePointService.activeFixPoint.longitude = selectCoordinatePointService.activeFixPoint.latLonDms.toLon()"
              >
                <option value="E">E</option>
                <option value="W">W</option></select
              ><input
                type="number"
                id="lonDegrees"
                name="lonDegrees"
                style="width: 16%"
                [(ngModel)]="selectCoordinatePointService.activeFixPoint.latLonDms.longitude.degrees"
                (ngModelChange)="selectCoordinatePointService.activeFixPoint.longitude = selectCoordinatePointService.activeFixPoint.latLonDms.toLon()"
                [disabled]="selectCoordinatePointService.selectedProcedureLeg != undefined? selectCoordinatePointService.isStraightlLeg : true"
              /><span>º</span
              ><input
                type="number"
                id="lonMinutes"
                name="lonMinutes"
                style="width: 16%"
                [(ngModel)]="selectCoordinatePointService.activeFixPoint.latLonDms.longitude.minutes"
                (ngModelChange)="selectCoordinatePointService.activeFixPoint.longitude = selectCoordinatePointService.activeFixPoint.latLonDms.toLon()"
                [disabled]="selectCoordinatePointService.selectedProcedureLeg != undefined? selectCoordinatePointService.isStraightlLeg : true"
              /><span>´</span
              ><input
                type="number"
                id="lonSeconds"
                name="lonSeconds"
                style="width: 16%"
                [(ngModel)]="selectCoordinatePointService.activeFixPoint.latLonDms.longitude.seconds"
                (ngModelChange)="selectCoordinatePointService.activeFixPoint.longitude = selectCoordinatePointService.activeFixPoint.latLonDms.toLon()"
                [disabled]="selectCoordinatePointService.selectedProcedureLeg != undefined? selectCoordinatePointService.isStraightlLeg : true"
              /><span></span>
              </div>
              <br /><input
                type="number"
                style="width: 75%; margin-top: 5px;margin-bottom:5px;"
                id="longitude"
                name="longitude"
                [(ngModel)]="selectCoordinatePointService.activeFixPoint.longitude"
                (ngModelChange)="selectCoordinatePointService.activeFixPoint.latLonDms.fromLat(selectCoordinatePointService.activeFixPoint.longitude)"
                [disabled]="selectCoordinatePointService.selectedProcedureLeg != undefined? selectCoordinatePointService.isStraightlLeg : true"
                required
              /><span></span>
            </div>
          </div>
          <div>
            <div class="btn">
              <button
              type="submit"
              class="grey"
              (click)="this.activateSelectOnMapFixPoint();"
              [disabled]="selectCoordinatePointService.selectedProcedureLeg != undefined? selectCoordinatePointService.isStraightlLeg : true">Select on Map</button>

            </div>
          </div>
          <div>
            <label for="">Radius</label>
            <div class="coordenates">
              <input
                type="number"
                style="width: 75%"
                id="radius"
                name="radius"
                [disabled]="true"
                [value]="selectCoordinatePointService.radius"
              /><span>[NM]</span>
            </div>
          </div>
          <div>
            <label for="">Arc length</label>
            <div class="coordenates">
              <input
                type="number"
                style="width: 75%"
                id="arc"
                name="arc"
                [disabled]="true"
                [value]="selectCoordinatePointService.arcLength"
              /><span>[NM]</span>
            </div>
          </div>
          <div>
            <input
              type="checkbox"
              id="straightLeg"
              name="straightLeg"
              [disabled]="selectCoordinatePointService.selectedProcedureLeg != null? false : true"
              [(ngModel)]="selectCoordinatePointService.isStraightlLeg"
              [checked]="selectCoordinatePointService.isStraightlLeg"
              (change)="this.changeLegFormat()"
            />
            <label for="">Straight Leg</label>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__btn">
      <button
        type="submit"
        [ngClass]="ngForm2.form.valid && projectService.activeProject?.editable? 'blue' : 'gray'"
        [disabled]="!ngForm2.form.valid || !projectService.activeProject?.editable"
        (click)="saveProcedure()"
      >Save</button>
      <a
        class="gray"
        href="#"
        type="reset"
        value="Cancel"
        (click)="tabsService.closeTab()"
        >Cancel</a>
    </div>
  </form>
  <form autocomplete="off"
    id="ngForm3"
    name="ngForm3"
    #ngForm3="ngForm"
    [ngClass]="[navaidsDataActive ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']"
    data-tab="1"
    id="navaidPrimaryForm"
  >
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="table-fields">
          <div>
            <div>
              <table>
                <thead>
                  <tr>
                    <th>Identification</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">IcaoCC</th>
                    <th scope="col">Critical</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let navaid of selectCoordinatePointService.selectedProcedure.navaids; let i = index" (click)="selectProcedureNavaid(navaid)"
                  [class.highlighted]="navaid.isselected">
                    <td>{{ navaid.navaidid }}</td>
                    <td>{{ navaid.name }}</td>
                    <td>{{ navaid.navaidtype }}</td>
                    <td>{{ navaid.icaocc }}</td>
                    <td><input
                      type="checkbox"
                      name="critical_{{i}}"
                      id="critical_{{i}}"
                      [checked]="navaid.critical"
                      [(ngModel)]="navaid.critical"
                      /></td>
                  </tr>
                </tbody>
              </table>
              <div class="btn">
                <a (click)="addNavaidFromMap()">Add From Map</a
                ><a (click)="deleteSelectedNavaidsFromList()">Delete From List</a
                ><a (click)="selectNavaidRows()">Show in Map</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__btn">
      <button
        type="submit"
        [ngClass]="ngForm3.form.valid && projectService.activeProject?.editable? 'blue' : 'gray'"
        [disabled]="!ngForm3.form.valid || !projectService.activeProject?.editable"
        (click)="saveProcedure()"
      >Save</button>
      <a
        class="gray"
        href="#"
        type="reset"
        value="Cancel"
        (click)="tabsService.closeTab()"
        >Cancel</a>
    </div>
  </form>
</div>
